import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './compat'
import { Provider } from 'react-redux';

import store from "./store";
import { loadData } from "./util";

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('comment-root')
);

loadData(store);